import { render, staticRenderFns } from "./CompanyClient.vue?vue&type=template&id=6b110cb0&scoped=true&"
import script from "./CompanyClient.vue?vue&type=script&lang=js&"
export * from "./CompanyClient.vue?vue&type=script&lang=js&"
import style0 from "./CompanyClient.vue?vue&type=style&index=0&id=6b110cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b110cb0",
  null
  
)

export default component.exports